import React, { FC, useRef } from 'react';
import { createPortal } from 'react-dom';

export interface PaymentIframeModalProps {
  isOpen: boolean;
  onClose: () => void;
  initialUrl?: string;
  onIframeLoad?: (iframe: HTMLIFrameElement) => void;
}

export const PaymentIframeModal: FC<PaymentIframeModalProps> = ({
  isOpen,
  onClose,
  initialUrl,
  onIframeLoad,
}) => {
  const iframeRef = useRef<HTMLIFrameElement>(null);

  const handleIframeLoad = () => {
    if (iframeRef.current && onIframeLoad) {
      onIframeLoad(iframeRef.current);
    }
  };

  if (!isOpen) return null;

  return createPortal(
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50">
      <div className="flex h-[90%] max-h-[600px] w-[90%] max-w-[800px] flex-col rounded-lg bg-white shadow-md max-md:h-full max-md:max-h-full max-md:w-full max-md:max-w-full max-md:rounded-none">
        <div className="flex justify-end border-b border-gray-200 p-3">
          <button
            type="button"
            className="cursor-pointer px-2 py-1 text-2xl text-gray-500 transition-colors duration-200 hover:text-gray-900"
            onClick={onClose}
            aria-label="閉じる"
          >
            ✕
          </button>
        </div>
        <iframe
          ref={iframeRef}
          className="w-full flex-1 border-none"
          title="決済画面"
          allow="payment"
          src={initialUrl}
          onLoad={handleIframeLoad}
        />
      </div>
    </div>,
    document.body,
  );
};
